import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  const forWho = ['Si gastás mucho en comida', 'Si querés empezar algo simple', 'Si no tenés experiencia', 'Si vivís en departamento'];
  const notForWho = ['Si no estás dispuesto a hacer nada', 'Si buscás resultados sin acción'];
  return <section className="w-full py-8 md:py-16 px-4 bg-gradient-to-b from-white to-green-50" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-104">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-green-200 rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-105">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 flex items-center gap-2" data-id="element-106">
              🧠 ¿Para quién es esto?
            </h3>
            <div className="space-y-3 md:space-y-4" data-id="element-107">
              {forWho.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-108">
                  <Check className="w-5 h-5 md:w-6 md:h-6 text-lime-600 flex-shrink-0 mt-0.5" data-id="element-109" />
                  <span className="text-sm md:text-base text-gray-800 font-medium" data-id="element-110">
                    {item}
                  </span>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-red-200 rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-111">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 flex items-center gap-2" data-id="element-112">
              🚫 ¿Para quién NO es?
            </h3>
            <div className="space-y-3 md:space-y-4" data-id="element-113">
              {notForWho.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-114">
                  <X className="w-5 h-5 md:w-6 md:h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-115" />
                  <span className="text-sm md:text-base text-gray-800 font-medium" data-id="element-116">
                    {item}
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}